// extracted by mini-css-extract-plugin
export default {"footer":"Jsix","footer_content":"_28XX","footer_logo":"_1A00","footer_link_container":"_2K6E","footer_link":"RiAS"};